import { render, staticRenderFns } from "./TeacherClass.vue?vue&type=template&id=694902f3&scoped=true"
import script from "./TeacherClass.vue?vue&type=script&lang=js"
export * from "./TeacherClass.vue?vue&type=script&lang=js"
import style0 from "./TeacherClass.vue?vue&type=style&index=0&id=694902f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694902f3",
  null
  
)

export default component.exports